import React from "react";

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  height?: "small" | "medium" | "large";
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = "Nhập nội dung...",
  height = "medium",
}) => {
  const getHeightClass = () => {
    switch (height) {
      case "small":
        return "h-32";
      case "medium":
        return "h-48";
      case "large":
        return "h-64";
      default:
        return "h-48";
    }
  };

  return (
    <div className="border border-gray-300 rounded-md">
      {/* Toolbar */}
      <div className="bg-gray-50 border-b border-gray-300 p-2">
        <div className="flex flex-wrap gap-1">
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("bold", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100 font-bold"
            type="button"
          >
            B
          </button>
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("italic", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100 italic"
            type="button"
          >
            I
          </button>
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("underline", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100 underline"
            type="button"
          >
            U
          </button>
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("insertUnorderedList", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100"
            type="button"
          >
            •
          </button>
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("insertOrderedList", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100"
            type="button"
          >
            1.
          </button>
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("justifyLeft", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100"
            type="button"
          >
            ←
          </button>
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("justifyCenter", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100"
            type="button"
          >
            →
          </button>
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("justifyRight", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100"
            type="button"
          >
            →
          </button>
          <button
            onClick={() => {
              const editor = document.querySelector(
                '[contenteditable="true"]'
              ) as HTMLElement;
              if (editor) {
                editor.focus();
                document.execCommand("removeFormat", false);
              }
            }}
            className="px-2 py-1 text-xs border border-gray-300 rounded bg-white hover:bg-gray-100"
            type="button"
          >
            Clear
          </button>
        </div>
      </div>

      {/* Editor Area */}
      <div
        contentEditable
        className={`p-4 ${getHeightClass()} bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 overflow-y-auto`}
        onInput={(e) => {
          const content = e.currentTarget.innerHTML;
          onChange(content);
        }}
        dangerouslySetInnerHTML={{ __html: value || "" }}
      />
      {!value && (
        <div className="p-4 text-gray-400 text-sm pointer-events-none">
          {placeholder}
        </div>
      )}

      {/* Footer */}
      <div className="bg-gray-50 border-t border-gray-300 px-4 py-2 text-right">
        <span className="text-xs text-gray-500">
          {value
            ? value
                .replace(/<[^>]*>/g, "")
                .split(/\s+/)
                .filter((word) => word.length > 0).length
            : 0}{" "}
          WORDS
        </span>
      </div>
    </div>
  );
};

export default RichTextEditor;
